<template>
  <div>
    <article class="am-article card">
      <div class="am-article-hd">
        <h1 class="am-article-title">{{title}}</h1>
      </div>
      <div v-highlight class="am-article-bd" v-html="html"></div>
    </article>
    <div class="am-panel am-panel-default am-margin-vertical-xl" v-if="status==3&&content==''">
      <div class="am-panel-bd">
        <span class="am-icon-lock am-icon-sm am-block am-text-center">「付费后可查看」</span>
        <div class="am-input-group">
          <input type="text" class="am-form-field am-radius" placeholder="请输入金额" v-model="password" @keyup.enter="submit"/>
          <span class="am-input-group-btn">
            <button class="am-btn am-btn-default am-radius" type="button" @click="submit">支付</button>
          </span>
        </div>
      </div>
    </div>
    <div v-if="allowComment">
      <div class="am-panel am-panel-default am-round am-margin-top" v-if="!loginUser">
        <div class="am-panel-bd am-text-center">
          请
          <router-link :to="{path:'/login'}">登录</router-link>
          后发表或查看评论
        </div>
      </div>
      <div v-if="loginUser">
        <div style="background-color: #fff; border-radius: 30px; padding: 24px; box-shadow: 0 0 70px 6px rgba(0,0,0,0.12);" class="am-form am-cf am-margin-top" v-if="commentShow">
          <div class="am-form-group">
            <label>
              <h2>添加新评论</h2>
            </label>
            <div style="height: 120px;">
              <div-editable id="commentContent" placeholder="请输入评论内容..." v-model="commentContent"></div-editable>
            </div>
          </div>
          <div class="am-fr">
            <button type="button" class="am-btn am-btn-default am-round" @click="commentBqBox"><span class="am-icon-smile-o"></span></button>
            <div class="am-btn-group">
              <button class="am-btn am-btn-success am-round" @click="saveComment(0, 0)">
                <span v-if="commentStatus===1">提交评论</span>
                <span v-if="commentStatus===2">匿名评论</span>
                <span v-if="commentStatus===3">悄悄话</span>
              </button>
              <div class="am-dropdown">
                <button class="am-btn am-btn-success am-round" @click="commentStatusPopupShow"> <span class="am-icon-caret-down"></span></button>
                <mt-popup v-model="commentStatusPopupVisible" style="position: absolute; left: 2px; top: 91.5px">
                  <div class="am-btn-group-stacked">
                    <button type="button" class="am-btn am-btn-default" @click="commentStatusClick(1)">公开</button>
                    <button type="button" class="am-btn am-btn-default" @click="commentStatusClick(2)">匿名</button>
                    <button type="button" class="am-btn am-btn-default" @click="commentStatusClick(3)">悄悄话</button>
                  </div>
                </mt-popup>
              </div>
            </div>
          </div>
          <div>
            <label class="am-checkbox-inline am-margin-top-xs">
              <input type="checkbox" v-model="notify"><b>邮件提醒</b>
            </label>
          </div>
          <div class="am-margin-top-xl" v-show="commentBqShow">
            <h3>表情</h3>
            <div style="height: 200px; overflow-y: scroll;">
              <div class="am-margin-bottom" v-for="bq in bqList">
                <h3>{{bq.name}}</h3>
                <button v-for="i in bq.list" class="am-btn-link am-padding-xs am-margin-xs" @click="insertAtCursor(bq.name, i.name, i.type)">
                  <img :src="`${option.fileUrl}/zero/bq/${bq.name}/${i.name}.${i.type?i.type:'png'}`" :alt="i.name" :title="i.name" style="width: 3rem; height: 3rem; position: relative; display: inline-block!important;"/>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <h3 class="am-cf am-margin-top" v-if="commentList&&commentList.length>0">
            已有 {{commentCount}} 条评论
          </h3>
          <div style="background-color: #f9f9f9; border-radius: 30px; padding: 24px" class="am-cf am-margin-top" v-for="comment in commentList" :key="comment.id" :id="`commentId${comment.id}`">
            <div style="width: 48px; margin-right: 16px" class="am-fl am-text-center">
              <img style="width: 48px" class="am-circle" :src="comment.authorFace"/>
              <a v-if="comment.likeFlag" href="javascript:void(0)" @click="dislikeComment(comment)">
                <span class="am-badge am-badge-bilibili am-round am-margin-top-sm am-icon-heart"> {{comment.likeCount <= 99 ? comment.likeCount : '99+'}}</span>
              </a>
              <a v-else href="javascript:void(0)" @click="likeComment(comment)">
                <span class="am-badge am-badge-bilibili am-round am-margin-top-sm am-icon-heart-o"> {{comment.likeCount <= 99 ? comment.likeCount : '99+'}}</span>
              </a>
            </div>
            <div style="margin-left:64px" class="am-cf">
              <div>
                <a v-if="comment.authorUrl" :href="comment.authorUrl" target="_blank">{{comment.authorName}}</a>
                <span v-else>{{comment.authorName}}</span>
                <span v-if="comment.authorFlag" class="am-badge am-badge-success am-radius">作者</span>
                <span v-if="comment.status==3" class="am-badge am-badge-danger am-radius">悄悄话</span>
              </div>
              <div v-if="comment.authorNote">
                <span style="color: #909090; font-size: 1.5rem">{{comment.authorNote}}</span>
              </div>
              <div style="font-size: 1.5rem">{{comment.createTime}}</div>
              <div class="am-margin-top-sm">
                <div v-html="comment.content"></div>
                <div class="am-fr">
                  <button class="am-btn am-btn-link" @click="deleteComment(comment.id)" v-if="comment.editFlag">删除</button>
                  <button class="am-btn am-btn-link" @click="tipOffComment(comment.id)" v-else>举报</button>
                  <button class="am-btn am-btn-link" @click="childComment(comment)">回复</button>
                </div>
                <div class="am-cf"></div>
              </div>
            </div>
            <div style="background-color: #fff; border-radius: 30px; padding: 24px; box-shadow: 0 0 70px 6px rgba(0,0,0,0.12);" class="am-form am-cf am-margin-bottom" v-if="comment.show">
              <div class="am-fr">
                <button class="am-btn am-btn-link" @click="commentInit">取消回复</button>
              </div>
              <div class="am-form-group">
                <label>
                  <h2>添加新回复</h2>
                </label>
                <div style="height: 120px;">
                  <div-editable id="commentContent" placeholder="请输入评论内容..." v-model="commentContent"></div-editable>
                </div>
              </div>
              <div class="am-fr">
                <button type="button" class="am-btn am-btn-default am-round" @click="commentBqBox"><span class="am-icon-smile-o"></span></button>
                <button type="button" class="am-btn am-btn-success am-round" @click="saveComment(comment.id, comment.id)">提交回复</button>
              </div>
              <div>
                <label class="am-checkbox-inline am-margin-top-xs">
                  <input type="checkbox" v-model="notify"><b>邮件提醒</b>
                </label>
              </div>
              <div class="am-margin-top-xl" v-show="commentBqShow">
                <h3>表情</h3>
                <div style="height: 200px; overflow-y: scroll;">
                  <div class="am-margin-bottom" v-for="bq in bqList">
                    <h3>{{bq.name}}</h3>
                    <button v-for="i in bq.list" class="am-btn-link am-padding-xs am-margin-xs" @click="insertAtCursor(bq.name, i.name, i.type)">
                      <img :src="`${option.fileUrl}/zero/bq/${bq.name}/${i.name}.${i.type?i.type:'png'}`" :alt="i.name" :title="i.name" style="width: 3rem; height: 3rem; position: relative; display: inline-block!important;"/>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="am-padding-left" v-if="comment.children">
              <div v-for="child in comment.children" :key="child.id" :id="`commentId${child.id}`">
                <div style="width: 48px; margin-right: 16px" class="am-fl am-text-center">
                  <img style="width: 48px" class="am-circle" :src="child.authorFace"/>
                  <a v-if="child.likeFlag" href="javascript:void(0)" @click="dislikeComment(child)">
                    <span class="am-badge am-badge-bilibili am-round am-margin-top-sm am-icon-heart"> {{child.likeCount <= 99 ? child.likeCount : '99+'}}</span>
                  </a>
                  <a v-else href="javascript:void(0)" @click="likeComment(child)">
                    <span class="am-badge am-badge-bilibili am-round am-margin-top-sm am-icon-heart-o"> {{child.likeCount <= 99 ? child.likeCount : '99+'}}</span>
                  </a>
                </div>
                <div style="margin-left:64px" class="am-cf">
                  <div>
                    <a v-if="child.authorUrl" :href="child.authorUrl" target="_blank">{{child.authorName}}</a>
                    <span v-else>{{child.authorName}}</span>
                    <span v-if="child.authorFlag" class="am-badge am-badge-success am-radius">作者</span>
                    <span v-if="child.status==3" class="am-badge am-badge-danger am-radius">悄悄话</span>
                  </div>
                  <div v-if="child.authorNote">
                    <span style="color: #909090; font-size: 1.5rem">{{child.authorNote}}</span>
                  </div>
                  <div style="font-size: 1.5rem">{{child.createTime}}</div>
                  <div class="am-margin-top-sm">
                    <div>
                      <b v-if="child.rootId!=child.commentId">
                        回复 {{child.ownerName}}
                        <span v-if="child.ownerFlag" class="am-badge am-badge-success am-radius">作者</span>
                      </b>
                      <span v-html="child.content"></span>
                    </div>
                    <div class="am-fr">
                      <button class="am-btn am-btn-link" @click="deleteComment(child.id)" v-if="child.editFlag">删除</button>
                      <button class="am-btn am-btn-link" @click="tipOffComment(child.id)" v-else>举报</button>
                      <button class="am-btn am-btn-link" @click="childComment(child)">回复</button>
                    </div>
                    <div class="am-cf"></div>
                  </div>
                </div>
                <div style="background-color: #fff; border-radius: 30px; padding: 24px; box-shadow: 0 0 70px 6px rgba(0,0,0,0.12);" class="am-form am-cf am-margin-bottom" v-if="child.show">
                  <div class="am-fr">
                    <button class="am-btn am-btn-link" @click="commentInit">取消回复</button>
                  </div>
                  <div class="am-form-group">
                    <label>
                      <h2>添加新回复</h2>
                    </label>
                    <div style="height: 120px;">
                      <div-editable id="commentContent" placeholder="请输入评论内容..." v-model="commentContent"></div-editable>
                    </div>
                  </div>
                  <div class="am-fr">
                    <button type="button" class="am-btn am-btn-default am-round" @click="commentBqBox"><span class="am-icon-smile-o"></span></button>
                    <button type="button" class="am-btn am-btn-success am-round" @click="saveComment(comment.id, child.id)">提交回复</button>
                  </div>
                  <div>
                    <label class="am-checkbox-inline am-margin-top-xs">
                      <input type="checkbox" v-model="notify"><b>邮件提醒</b>
                    </label>
                  </div>
                  <div class="am-margin-top-xl" v-show="commentBqShow">
                    <h3>表情</h3>
                    <div style="height: 200px; overflow-y: scroll;">
                      <div class="am-margin-bottom" v-for="bq in bqList">
                        <h3>{{bq.name}}</h3>
                        <button v-for="i in bq.list" class="am-btn-link am-padding-xs am-margin-xs" @click="insertAtCursor(bq.name, i.name, i.type)">
                          <img :src="`${option.fileUrl}/zero/bq/${bq.name}/${i.name}.${i.type?i.type:'png'}`" :alt="i.name" :title="i.name" style="width: 3rem; height: 3rem; position: relative; display: inline-block!important;"/>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="postMenu">
      <a v-if="!postMenuVisible" @click="postMenuShow" class="postMenuShow am-icon-btn am-icon-bars"> </a>
      <mt-popup v-model="postMenuVisible" position="right" class="postMenu">
        <h1>目录</h1>
        <div v-html="postMenu" @click="postMenuChick"></div>
        <a @click="postMenuHide" class="postMenuHide am-close am-close-alt am-close-spin am-icon-times"></a>
      </mt-popup>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import marked from 'marked'
import hljs from "highlight.js"
import 'highlight.js/styles/vs2015.css'
import { apiPageGet, apiCommentGetList, apiCommentSave, apiCommentDelete, apiCommentTipOff, apiLikeSave, apiLikeDelete, getBqJson } from '@/request'
import {MessageBox, Toast} from "mint-ui"
import DivEditable from "@/components/DivEditable"
export default {
  name: 'Page',
  components: {
    DivEditable
  },
  data () {
    return {
      id: null,
      slug: null,
      title: '',
      content: '',
      commentCount: 0,
      allowComment: false,
      status: 1,
      password: '',
      description: '',
      commentShow: true,
      commentBqShow: false,
      commentStatus: 1,
      commentContent: '',
      commentList: [],
      bqList: [],
      notify: true,
      commentStatusPopupVisible: false,
      postMenu: '',
      postMenuVisible: false
    }
  },
  mounted () {
    this.resetData()
  },
  updated () {
    this.$nextTick(() => {
      const commentId = this.$route.query.commentId
      if(commentId) {
        const anchor = this.$el.querySelector(`#commentId${commentId}`)
        if(anchor) {
          anchor.scrollIntoView()
        }
      }
      const header = this.$route.query.header
      if(header) {
        const anchor = this.$el.querySelector(`#header${header}`)
        if(anchor) {
          anchor.scrollIntoView()
        }
      }
    })
  },
  computed: {
    ...mapGetters([ 'option', 'loginUser' ]),
    html () {
      return marked.parse(this.content)
    }
  },
  watch: {
    $route: {
      handler: 'resetData'
    },
    title () {
      this.seo()
    },
    option () {
      this.seo()
    },
    html () {
      this.$nextTick(() => {
        const reg = /^<[hH]([1-6]) id="([\s\S]*)">([\s\S]*)<\/[hH][1-6]>$/
        const headers = this.html.split(/[\r\n\t]/).filter(item => reg.test(item))
        const min = Math.min(...headers.map(item => item.replace(reg, '$1')));
        this.postMenu = headers.map(item => {
          return item.replace(reg, `<p style="margin-left: ${(item.replace(reg, '$1') - min) * 20}px;"><a href="javascript:void(0)" data-id="#$2">$3</a></p>`)
        }).join('')
      })
    }
  },
  methods: {
    resetData () {
      if(window.innerWidth >= 1280) {
        this.postMenuVisible = true
      }
      if(this.$route.query.commentId && !this.loginUser) {
        this.$router.push({path:'/login'})
      }
      this.slug = this.$route.params.slug
      this.password = this.$route.query.password
      if(this.slug) {
        apiPageGet({ slug: this.slug, password: this.password, description: true }).then(res => {
          this.id = res.id
          this.title = res.title
          this.content = res.content
          this.commentCount = res.commentCount
          this.allowComment = res.allowComment
          this.status = res.status
          this.description = res.description
          if(this.status == 3 && this.content == '' && this.password) {
            Toast('密码错误，请重试。')
          }
          this.password = ''
          this.loadCommentList()
        })
      }
      const renderer = new marked.Renderer()
      const linkRenderer = renderer.link
      renderer.link = (href, title, text) => {
        const html = linkRenderer.call(renderer, href, title, text)
        return html.replace(/^<a /, '<a target="_blank" ')
      }
      marked.setOptions({
        renderer: renderer,
        pedantic: false,
        gfm: true,
        tables: true,
        breaks: true,
        sanitize: false,
        smartLists: true,
        smartypants: false,
        xhtml: false,
        headerPrefix: "header"
      })
    },
    seo () {
      if(this.title) {
        document.title = `${this.title}｜${this.option.title}`
        document.querySelector('meta[name="description"]').setAttribute('content', `${this.description}`)
        document.querySelector('meta[name="keywords"]').setAttribute('content', `${this.option.keywords},${this.title}`)
      } else {
        document.title = this.option.title
        document.querySelector('meta[name="description"]').setAttribute('content', this.option.description)
        document.querySelector('meta[name="keywords"]').setAttribute('content', this.option.keywords)
      }
    },
    submit () {
      if(this.password) {
        this.$router.push({path:`/${this.slug}?password=${this.password}`})
      }
    },
    loadCommentList () {
      if(this.loginUser) {
        apiCommentGetList({
          sceneType: 2,
          sceneId: this.id
        }).then(res => {
          this.commentList = res
          this.commentInit()
        })
        getBqJson().then(res => {
          this.bqList = res
        })
      }
    },
    childComment(comment) {
      this.commentInit()
      this.commentShow = false
      this.commentBqShow = false
      comment.show = true
    },
    commentInit() {
      this.commentList.forEach(comment => {
        comment.show = false
        if(comment.children) {
          comment.children.forEach(child => {
            child.show = false
          })
        }
      })
      this.commentShow = true
      this.commentBqShow = false
      this.commentContent = ''
      this.commentStatus = 1
      document.querySelector('#commentContent').innerHTML = ''
    },
    saveComment (rootId, commentId) {
      if(this.commentContent) {
        apiCommentSave({
          sceneType: 2,
          sceneId: this.id,
          content: this.commentContent,
          status: this.commentStatus,
          notify: this.notify,
          rootId,
          commentId
        }).then(res => {
          this.commentCount = res
          this.loadCommentList()
          Toast('提交成功')
        })
      }
    },
    deleteComment(id) {
      MessageBox.confirm('确定删除吗？').then(() => {
        apiCommentDelete({id}).then(res => {
          this.commentCount = res
          this.loadCommentList()
          Toast('删除成功')
        })
      })
    },
    tipOffComment(id) {
      MessageBox.prompt('举报描述：').then(({ value }) => {
        if(value) {
          apiCommentTipOff({id, value}).then(() => {
            Toast('举报成功')
          })
        }
      })
    },
    commentBqBox () {
      this.commentBqShow = !this.commentBqShow
    },
    insertAtCursor(a, b, c) {
      var box = document.querySelector('#commentContent')
      var nbsp = document.createTextNode(" ")
      var img = document.createElement('img'); // 要插入的表情img
      img.src = `${this.option.fileUrl}/zero/bq/${a}/${b}.${c?c:'png'}`
      img.alt = b
      img.title = b
      img.className = 'bq'
      var selection = window.getSelection()
      if(!selection.containsNode(box, true)) {
        box.focus()
        selection.selectAllChildren(box)
        selection.collapseToEnd()
      }
      var range = selection.getRangeAt(0)
      range.insertNode(nbsp.cloneNode())
      range.insertNode(img.cloneNode())
      range.insertNode(nbsp.cloneNode())
      range.collapse()
      selection.removeAllRanges()
      selection.addRange(range)
      this.commentBqShow = false
      this.commentContent = box.innerHTML
    },
    likeComment (comment) {
      apiLikeSave({
        sceneType: 3,
        sceneId: comment.id
      }).then(() => {
        comment.likeFlag = true
        comment.likeCount += 1
        Toast('点赞成功')
      })
    },
    dislikeComment (comment) {
      // apiLikeDelete({
      //   sceneType: 3,
      //   sceneId: comment.id
      // }).then(() => {
      //   comment.likeFlag = false
      //   comment.likeCount -= 1
      //   if(comment.likeCount < 0) {
      //     comment.likeCount = 0
      //   }
      //   Toast('取消点赞成功')
      // })
      Toast('您已经点过赞啦')
    },
    commentStatusPopupShow () {
      this.commentStatusPopupVisible = !this.commentStatusPopupVisible
    },
    commentStatusClick (commentStatus) {
      this.commentStatus = commentStatus
      this.commentStatusPopupVisible = false
    },
    postMenuShow () {
      this.postMenuVisible = true
    },
    postMenuHide () {
      this.postMenuVisible = false
    },
    postMenuChick (e) {
      const anchor = this.$el.querySelector(e.target.getAttribute('data-id'))
      if(anchor) {
        anchor.scrollIntoView()
      }
      this.postMenuVisible = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page.vue